export default "__VITE_ASSET__CJvOaCYa__"